import React, { type ReactNode } from "react";

export function MobileInvitationFrame({
  children,
}: {
  children: ReactNode;
}): React.ReactElement {
  return (
    <div className="flex lg:hidden justify-center items-center h-full md:min-h-dvh w-screen print:min-h-screen px-4 md:px-8 gap-4 py-6">
      <div
        id="party-invitation-card-mobile"
        data-invitation-card
        className="relative w-full md:w-2/3 print:max-w-5xl flex flex-col items-center justify-center mx-auto p-6 md:p-10 border border-orange-2 rounded-3xl bg-background-light"
      >
        {children}
      </div>
    </div>
  );
}
